import { Box, Container, Typography } from "@mui/material";
import ReactMarkdown from "react-markdown";
import remarkBreaks from "remark-breaks";
import remarkGfm from "remark-gfm";

import Page from "../elements/Page";

const Privacy = () => {
  return (
    <>
      <Page title="모두의 치아(모치) 서비스 개인정보처리방침">
        <Container sx={{ pb: 5 }}>
          <Box sx={{ my: 5 }} display="flex">
            <Typography variant="h4">모두의 치아(모치) 서비스 개인정보처리방침</Typography>
          </Box>

          <ReactMarkdown
              components={{
                  h1: ({children}) => <Typography variant="h1">{children}</Typography>,
                  h2: ({children}) => <Typography variant="h2">{children}</Typography>,
                  h3: ({children}) => <Typography variant="h3">{children}</Typography>,
                  h4: ({children}) => <Typography variant="h4" sx={{ mx: 1, my: 3 }}>{children}</Typography>,
                  h5: ({children}) => <Typography variant="h5" sx={{ mx: 2, my: 2 }}>{children}</Typography>,
                  h6: ({children}) => <Typography variant="h6" sx={{ mx: 3, my: 1 }}>{children}</Typography>,
                  p: ({children}) => <Typography variant="p" sx={{ mx: 3 }}>{children}</Typography>,
                  ul: ({children}) => <ul style={{padding: "0 20px"}}>{children}</ul>,
              }}
              remarkPlugins={[remarkBreaks, remarkGfm]}>{`
본 서비스는 귀하의 개인 정보를 보호하기 위해 최선을 다하고 있습니다. 서비스의 제공 및 이용에 있어 수집되는 개인정보의 처리 및 보호를 위해 아래와 같은 방침을 적용합니다. 본 개인정보처리방침은 관련 법령에 따라 변경될 수 있으며, 변경 시 별도 공지합니다.

#### 1. 개인정보의 수집 항목 및 수집 방법
#### 수집 항목
- 회원 가입 시: 이름
- 진료 기록 저장 시: 진료 일자, 치료 내용, 치과 정보
- 서비스 이용 시 자동으로 수집되는 정보: 접속 IP 주소, 접속 기록, 이용 로그, 디바이스 정보
#### 수집 방법
- 사용자가 직접 입력하는 방식
- 서비스 이용 과정에서 자동으로 수집되는 방식 (쿠키 및 유사한 기술을 통한 정보 수집)

#### 2. 개인정보의 수집 및 이용 목적
본 서비스는 수집된 개인정보를 다음의 목적을 위해 사용합니다:
- 진료 기록 조회 및 관리
- 서비스 개선을 위한 분석 및 통계 처리

#### 3. 개인정보의 보유 및 이용 기간
수집된 개인정보는 다음 기준에 따라 보유 및 이용됩니다:
- 회원 탈퇴 시: 해당 회원의 개인정보는 즉시 파기됩니다.
- 법령에 의한 보존: 관계 법령에 따라 일정 기간 동안 개인정보를 보관할 수 있으며, 해당 기간 동안 별도 보관됩니다.

#### 4. 개인정보의 제3자 제공
본 서비스는 원칙적으로 이용자의 개인정보를 제3자에게 제공하지 않습니다. 다만, 다음의 경우에 한하여 개인정보를 제3자에게 제공할 수 있습니다:
- 이용자가 사전에 동의한 경우
- 법령에 의거하여 관계 당국이 요구하는 경우

#### 5. 개인정보의 처리 위탁
서비스 운영을 위해 외부 업체에 개인정보 처리를 위탁할 수 있으며, 위탁 시에는 정보보호가 충분히 보장되도록 관리합니다. 위탁사 및 위탁 업무는 공지사항을 통해 안내드립니다.

#### 6. 이용자의 권리 및 행사 방법
이용자는 언제든지 본인의 개인정보에 대해 조회, 수정, 삭제, 처리 정지를 요청할 수 있습니다. 개인정보 관련 권리 행사를 위해 고객센터를 통해 연락하시면 신속히 처리해 드립니다.

#### 7. 개인정보의 안전성 확보 조치
회사는 이용자의 개인정보를 안전하게 보호하기 위해 다음과 같은 조치를 취하고 있습니다:
- 개인정보 접근 제한: 개인정보 처리자에 대해 권한 관리 및 접근 통제를 시행합니다.
- 암호화 처리: 중요 정보는 암호화하여 저장 및 전송합니다.
- 보안 관리 체계 운영: 해킹 및 컴퓨터 바이러스에 대응하기 위한 보안 관리 체계를 갖추고 있습니다.

#### 8. 개인정보 처리방침의 변경
본 개인정보처리방침은 관계 법령 및 회사 정책에 따라 개정될 수 있으며, 변경 시 공지사항을 통해 안내드릴 예정입니다.

#### 9. 개인정보 보호책임자 및 문의처
- 개인정보 보호책임자: 김대현, 대표이사
- 연락처: 070-8095-5066 / cs@beyondmedicine.kr    
이 정책은 2024.11.06부터 적용됩니다.
`}</ReactMarkdown>
        </Container>
      </Page>
    </>
  );
};

export default Privacy;
